<template>
  <v-row class="ma-0">
    <v-col class="text-center pa-0">
      <v-card>
        <v-col
          v-if="creationAccess"
          class="text-center px-0 py-1"
        >
          <v-tooltip
            v-for="tool in toolList"
            :key="tool.icon"
            open-delay="1000"
            right
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                :class="getMargin"
                v-on="on"
                @click="selectTool(tool.toolType)"
              >
                <v-icon :size="getIconSize">
                  {{ tool.icon }}
                </v-icon>
              </v-btn>
            </template>
            <img
              v-if="tool.title.includes('.gif')"
              class="mt-2"
              :src="tool.title"
            />
            <span v-else>{{ $t(tool.title) }}</span>
          </v-tooltip>
          <dialog-text-editor
            :current-object="currentObject"
            icon="mdi-format-textbox"
            :get-size="getIconSize"
            :no-tool-tip="false"
            :title-tool-tip="$t('creation.tools.text')"
            tool-name="text"
            @toolSelectedFromDialog="selectToolFromDialog"
            @textEdit="textEdit"
            @textEditElement="editElement"
          />
          <dialog-scrolling-text
            icon="mdi-format-text-rotation-down-vertical"
            :get-size="getIconSize"
            tool-name="scrolling"
            :color="mainColor"
            :current-object="currentObject"
            :label="$t('creation.tools.dialog.rss.scroll')"
            :no-tool-tip="false"
            :title-tool-tip="$t('creation.tools.dialog.rss.scroll')"
            @toolSelectedFromDialog="selectToolFromDialog"
            @textScrolling="textScrollingSelected"
            @editElement="editElement"
          />
          <dialog-open-file
            :get-size="getIconSize"
            icon="image"
            :current-object="currentObject"
            :file-filter="['.bmp', '.gif', '.jpeg', '.jpg', '.png', '.svg']"
            :shared-media="true"
            tool-name="image"
            :no-tool-tip="false"
            :size-project="sizeProject"
            :title-tool-tip="'https://dmpos.com/dmcvision/creation_img.gif'"
            @toolSelectedFromDialog="selectToolFromDialog"
            @fileSelected="imageSelected"
            @editElement="editElement"
          />
          <dialog-open-file
            icon="mdi-file-pdf-box"
            :get-size="getIconSize"
            tool-name="pdf"
            :file-filter="['.pdf']"
            :selectable="false"
            :activatable="true"
            :no-tool-tip="false"
            :size-project="sizeProject"
            :title-tool-tip="$t('creation.tools.dialog.pdf.title')"
            @toolSelectedFromDialog="selectToolFromDialog"
            @fileSelected="pdfSelected"
          />
          <dialog-new-pdf
            :list-pdf.sync="listPdf"
            :current-object="currentObject"
            @toolSelectedFromDialog="selectToolFromDialog"
            @fileSelected="pdfSelected"
            @pdfEditConfig="editElement"
          />
          <dialog-open-file
            icon="mdi-video"
            :get-size="getIconSize"
            tool-name="video"
            :current-object="currentObject"
            :file-filter="['.mp4', '.webm']"
            :selectable="false"
            :shared-media="true"
            :activatable="true"
            :no-tool-tip="false"
            :size-project="sizeProject"
            :title-tool-tip="'https://dmpos.com/dmcvision/creation_video.gif'"
            @toolSelectedFromDialog="selectToolFromDialog"
            @fileSelected="videoSelected"
            @editElement="editElement"
          />
          <dialog-web
            icon="mdi-web"
            :get-size="getIconSize"
            tool-name="web"
            :rules="urlRules"
            :label="$t('creation.tools.dialog.web')"
            :no-tool-tip="false"
            :current-object="currentObject"
            :title-tool-tip="$t('creation.tools.web')"
            @toolSelectedFromDialog="selectToolFromDialog"
            @textEntered="webSelected"
            @editElement="editElement"
          />
          <dialog-weather
            icon="mdi-weather-partly-cloudy"
            :get-size="getIconSize"
            tool-name="weather"
            :label="$t('creation.tools.dialog.weather-name')"
            :color="mainColor"
            :no-tool-tip="false"
            :current-object="currentObject"
            :title-tool-tip="$t('creation.tools.weather')"
            @toolSelectedFromDialog="selectToolFromDialog"
            @weatherSelected="weatherSelected"
            @editElement="editElement"
          />
          <dialog-rss-settings
            icon="mdi-rss"
            :get-size="getIconSize"
            tool-name="scrolling"
            :rules="urlRules"
            :color="mainColor"
            :current-object="currentObject"
            :label="$t('creation.tools.dialog.rss.feed')"
            :no-tool-tip="false"
            :title-tool-tip="$t('creation.tools.rss')"
            @toolSelectedFromDialog="selectToolFromDialog"
            @rssConfigDone="rssSelected"
            @editElement="editElement"
          />
          <dialog-calendar-fields
            icon="mdi-calendar-clock"
            :get-size="getIconSize"
            tool-name="calendar"
            :color="mainColor"
            :current-object="currentObject"
            :label="$t('creation.tools.calendar')"
            :no-tool-tip="false"
            :title-tool-tip="$t('creation.tools.calendar')"
            @toolSelectedFromDialog="selectToolFromDialog"
            @calendarSelect="calendarSelected"
          />
        </v-col>

        <v-divider
          v-if="creationAccess"
          class="my-1"
        />

        <v-col class="text-center px-0 py-1">
          <v-tooltip
            v-for="tool in toolBasic"
            :key="tool.icon"
            open-delay="1000"
            right
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                :class="getMargin"
                v-on="on"
                @click="selectTool(tool.toolType)"
              >
                <v-icon :size="getIconSize">
                  {{ tool.icon }}
                </v-icon>
              </v-btn>
            </template>
            <img
              v-if="tool.title.includes('.gif')"
              class="mt-2"
              :src="tool.title"
            />
            <span v-else>{{ $t(tool.title) }}</span>
          </v-tooltip>
          <div>
            <v-menu
              v-model="menuZoom"
              :close-on-content-click="false"
              :nudge-right="10"
              offset-x
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  :class="getMargin"
                  v-bind="attrs"
                  v-on="on"
                  @click="selectTool('zoom')"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <v-card
                class="d-flex align-center"
                :min-height="50"
              >
                <v-btn
                  class="align-center"
                  icon
                  @click="selectTool('zoomPlus')"
                >
                  <v-icon>mdi-magnify-plus-outline</v-icon>
                </v-btn>
                <v-btn
                  class="align-center"
                  icon
                  @click="selectTool('zoomMinus')"
                >
                  <v-icon>mdi-magnify-minus-outline</v-icon>
                </v-btn>
                <v-btn
                  class="align-center"
                  icon
                  @click="selectTool('zoomResize'), (menuZoom = false)"
                >
                  <v-icon>mdi-magnify-scan</v-icon>
                </v-btn>
              </v-card>
            </v-menu>
          </div>
          <v-divider />
          <v-col class="text-center px-0 py-0">
            <div class="px-1 pt-2 pb-1">
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <div
                    class="secondary-color color-box"
                    :style="'background-color:' + secondaryColorSelected"
                    v-on="on"
                  />
                </template>
                <v-color-picker
                  v-model="secondaryColorSelected"
                  mode="hexa"
                />
              </v-menu>
              <v-menu :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <div
                    class="main-color color-box"
                    :style="'background-color:' + mainColorSelected"
                    v-on="on"
                  />
                </template>
                <v-color-picker
                  v-model="mainColorSelected"
                  mode="hexa"
                />
              </v-menu>
              <v-row class="mx-0">
                <v-col
                  class="px-0 text-center"
                  cols="6"
                >
                  <v-btn
                    x-small
                    icon
                    @click="invertColors()"
                  >
                    <v-icon x-small>mdi-swap-horizontal</v-icon>
                  </v-btn>
                </v-col>
                <v-col
                  class="px-0 text-center"
                  cols="6"
                >
                  <v-btn
                    x-small
                    icon
                    @click="resetColors()"
                  >
                    <v-icon x-small>mdi-undo</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-divider />
          <v-col
            v-if="false"
            class="text-center px-0"
          >
            <div>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-bottom="70"
                :nudge-right="8"
                :nudge-width="35"
                offset-x
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    :class="getMargin"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon :size="getIconSize">mdi-tune-vertical-variant</v-icon>
                  </v-btn>
                </template>
                <v-card
                  class="d-flex"
                  :min-height="220"
                >
                  <v-slider
                    v-model="getIconSize"
                    class="align-self-center"
                    vertical
                    :max="45"
                    :min="25"
                    step="1"
                  />
                </v-card>
              </v-menu>
            </div>
          </v-col>

          <v-col class="text-center px-0 pb-0">
            <div class="">
              <v-btn
                icon
                :class="getMargin"
              >
                <v-icon
                  :size="getIconSize"
                  @click="projectPreview"
                >
                  mdi-overscan
                </v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col class="text-center pb-1 pa-0">
            <div class="">
              <v-btn
                icon
                :class="getMargin"
              >
                <v-icon
                  :size="getIconSize"
                  @click="projectPreviewAnimations"
                >
                  mdi-motion-play-outline
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-col>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// Components
import dialogScrollingText from "../Dialog/DialogScrollingText";
import dialogOpenFile from "../Dialog/DialogOpenFile";
import dialogTextEditor from "../Dialog/DialogTextEditor";
import dialogRssSettings from "../Dialog/DialogRssSettings";
import dialogCalendarFields from "../Dialog/DialogCalendarFields";
import dialogNewPdf from "../Dialog/DialogNewPDF";
import dialogWeather from "../Dialog/DialogWeather";
import dialogWeb from "../Dialog/DialogWeb";

// Tools
const rectangleTool = require("./EditTools/RectangleTool");
const videoTool = require("./EditTools/VideoTool");
const buttonTool = require("./EditTools/ButtonTool");
const textTool = require("./EditTools/TextTool");
const imageTool = require("./EditTools/ImageTool");
const pdfTool = require("./EditTools/PdfTool");
const webTool = require("./EditTools/WebTool");
const calendarTool = require("./EditTools/CalendarTool");
const scrollingTool = require("./EditTools/ScrollingTool");
const weatherTool = require("./EditTools/WeatherTool");

function createToolObject(name, icon, toolType, title) {
  const tool = {
    name: name,
    icon: icon,
    toolType: toolType,
    title: title,
  };

  return tool;
}

const toolBasic = [
  createToolObject(
    "Pointer",
    "mdi-cursor-default-outline",
    { name: "pointer", type: "basic" },
    "https://dmpos.com/dmcvision/creation_select.gif"
  ),
  createToolObject("Move", "mdi-arrow-all", { name: "move", type: "basic" }, "creation.tools.move"),
  createToolObject(
    "Duplicate",
    "mdi-content-duplicate",
    { name: "duplicate", type: "basic" },
    "creation.tools.duplicate"
  ),
];

const toolList = [
  createToolObject(
    "Square",
    "mdi-crop-square",
    new rectangleTool.Rectangle(),
    "https://dmpos.com/dmcvision/creation_rect.gif"
  ),
];

const toolFromDialog = {
  image: createToolObject("Image", "image", new imageTool.Picture(), "https://dmpos.com/dmcvision/creation_img.gif"),
  text: createToolObject("Text", "format-textbox", new textTool.Text(), "creation.tools.text"),
  pdf: createToolObject("Pdf", "file-pdf-box", new pdfTool.Pdf(), "Convertir pdf"),
  video: createToolObject("Video", "video", new videoTool.Video(), "https://dmpos.com/dmcvision/creation_video.gif"),
  web: createToolObject("Website", "web", new webTool.Web(), "Afficher un site web"),
  weather: createToolObject("Weather", "weather", new weatherTool.Weather(), "Afficher la météo"),
  calendar: createToolObject(
    "Calendar",
    "calendar-clock",
    new calendarTool.Calendar(),
    "Ajouter des champs textes dynamiques"
  ),
  scrolling: createToolObject(
    "Scrolling",
    "format-text-rotation-down-vertical",
    new scrollingTool.Scrolling(),
    "Ajouter un texte defilant"
  ),
  button: createToolObject("Button", "button", new buttonTool.Button(), "Ajouter un bouton redirigeant vers un projet"),
};

export default {
  components: {
    dialogOpenFile,
    dialogTextEditor,
    dialogScrollingText,
    dialogRssSettings,
    dialogCalendarFields,
    dialogNewPdf,
    dialogWeather,
    dialogWeb,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    sizeProject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      creationAccess: false,
      listPdf: {},
      mainColor: "#FFFFFFFF",
      menu: false,
      menuZoom: false,
      newPdf: false,
      secondaryColor: "#000000FF",
      toolBasic,
      toolList,
      urlRules: {
        filter: {
          required: (v) => !!v || "Required.",
          // eslint-disable-next-line
          regex: (v) =>
            /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g.test(v) ||
            "Url must be valid",
        },
      },
    };
  },
  computed: {
    getIconSize() {
      return this.$store.state.config.prefs.iconSize;
    },
    getMargin() {
      if (this.getIconSize > 35) {
        return "my-1";
      } else {
        return "my-0";
      }
    },
    mainColorSelected: {
      get: function () {
        return this.mainColor;
      },
      set: function (newValue) {
        this.mainColor = newValue;
        this.$emit("mainColor", this.mainColor);
      },
    },
    secondaryColorSelected: {
      get: function () {
        return this.secondaryColor;
      },
      set: function (newValue) {
        this.$emit("secondaryColor", this.secondaryColor);
        this.secondaryColor = newValue;
      },
    },
  },
  watch: {
    listPdf: function (val) {
      this.selectToolFromDialog("image");
      this.imageSelected(val, "pdf");
    },
  },
  mounted() {
    this.$emit("mainColor", this.mainColor);
    this.creationAccess = this.$store.state.user.permissions.includes("1|");
  },
  methods: {
    resetColors() {
      this.mainColorSelected = "#FFFFFFFF";
      this.secondaryColorSelected = "#000000FF";
    },
    invertColors() {
      let cMain = this.mainColorSelected;

      this.mainColorSelected = this.secondaryColorSelected;
      this.secondaryColorSelected = cMain;
    },
    calendarSelected(radio, valDate, valHour, date, noText) {
      toolFromDialog["calendar"].toolType.calendar(radio, valDate, valHour, date, noText, this.mainColor);
    },
    imageSelected(imageSelected, name = "Image") {
      toolFromDialog["image"].toolType.image(imageSelected, name);
    },
    pdfSelected(pdfSelected) {
      toolFromDialog["pdf"].toolType.pdf(pdfSelected[0]);
    },
    projectPreview() {
      this.$emit("projectPreview");
    },
    projectPreviewAnimations() {
      this.$emit("startProjectPreviewAnimations");
    },
    selectTool(tool) {
      if (tool.name === "duplicate") {
        this.duplicateElement();
        return;
      }
      if (tool == "zoom") {
        tool = { name: "zoom", type: "basic" };
      } else if (tool == "zoomPlus") {
        tool = { name: "zoomPlus", type: "basic" };
      } else if (tool == "zoomMinus") {
        tool = { name: "zoomMinus", type: "basic" };
      } else if (tool == "zoomResize") {
        tool = { name: "zoomResize", type: "basic" };
      }
      this.$emit("toolSelected", tool);
    },
    selectToolFromDialog(toolName) {
      this.$emit("toolSelected", toolFromDialog[toolName].toolType);
    },
    videoSelected(videoSelected) {
      toolFromDialog["video"].toolType.video(videoSelected);
    },
    webSelected(data) {
      toolFromDialog["web"].toolType.web(data.url);
      toolFromDialog["web"].toolType.static(data.isFullscreen);
    },
    weatherSelected(dataWeather) {
      toolFromDialog["weather"].toolType.weather(dataWeather, "Weather");
    },
    textScrollingSelected(dataScrolling) {
      toolFromDialog["scrolling"].toolType.scrolling(dataScrolling, "Scrolling");
    },
    rssSelected(dataScrolling) {
      toolFromDialog["scrolling"].toolType.scrolling(dataScrolling, "rss");
    },
    buttonSelected(nameProject) {
      toolFromDialog["button"].toolType.button(nameProject);
    },
    textEdit(text) {
      toolFromDialog["text"].toolType.setText(text);
    },
    editElement(newElement) {
      let name = newElement.name;
      let tool = newElement.name;

      if (name && tool) {
        // TODO: Check why we change tool in cases and name in default...
        switch (tool) {
          case "pdf":
            tool = "image";
            break;
          case "rss":
            tool = "scrolling";
            break;

          default:
            name = newElement.name.substring(0, 1).toUpperCase() + newElement.name.substring(1);
            break;
        }
        toolFromDialog[tool].toolType.setContent(newElement.content, name);
        toolFromDialog[tool].toolType.setConfig(newElement.config);

        this.$emit("editElement", toolFromDialog[tool].toolType);
      }
    },
    duplicateElement() {
      this.$emit("cloned", this.currentObject);
    },
  },
};
</script>

<style>
.color-box {
  position: relative;
  width: 25px;
  height: 25px;
  border: 1px solid white;
  box-shadow: 0px 0px 3px black;
}

.main-color {
  top: -20px;
}

.secondary-color {
  top: 15px;
  left: 10px;
}
</style>
